import { Container, Carousel } from "react-bootstrap";
import '../Home_css/events.css';
// import event1 from "../../Assets/Dahlia_events/Events_03.jpg";
// import event2 from "../../Assets/Dahlia_events/Events_02.jpg";
import event3 from "../../Assets/Dahlia_events/Events_01.jpg";
import event4 from "../../Assets/Dahlia_events/Events_04.jpg";


const Events = () => {
  return (
    <section id="events">
      <Container>
        <div className="Events">
          <div className="row">
            {/* Left Column - Image Carousel */}
            <div className="col-md-6">
              <div className="row">
                <div className="col p-4 d-flex flex-column position-static">
                  <Carousel>
                    {/* <Carousel.Item>
                      <img src={event1} className="d-block w-100" alt="Discovery Day" />
                    </Carousel.Item> */}
                    {/* <Carousel.Item>
                      <img src={event2} className="d-block w-100" alt="CryoCon Event" />
                    </Carousel.Item> */}
                    <Carousel.Item>
                      <img src={event3} className="d-block w-100" alt="EMX Event" />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img src={event4} className="d-block w-100" alt="Wellness Expo" />
                    </Carousel.Item>
                  </Carousel>
                </div>
              </div>
            </div>

            {/* Right Column - Event Description */}
            <div className="col-md-6 d-flex align-items-center">
              <div className="col p-4 d-flex flex-column">
                <h1 className="text-white text-start">Where To Find Us</h1>
                <p className="text-white text-start">
                  Stay up to date with our latest events and catch us at conferences across the United States!
                  We regularly attend industry-leading expos and trade shows, giving you the perfect opportunity
                  to see our red light therapy beds in action, ask questions, and connect with our team.
                  For private events, we have created our Dahlia Discovery Day where you can meet
                  us in our offices for a more personalized experience. Whether you're looking to expand your business,
                  explore the latest wellness technology, or simply learn more about the benefits of red light therapy,
                  meeting us in person is the best way to experience it all.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Events;
